<template>
  <div class="panel panel-default version-card">
    <template v-if="loadingVideo">
      <div class="row">
        <div class="col-md-12 text-center">
          <loader class="loader">
            <p slot="text">Loading...</p>
          </loader>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="panel-heading clearfix">
        <div tabindex="0" class="pull-left ml-10 header-title">
          <h3><b>Resource Library</b></h3>
        </div>
        <div class="pull-right mt-10 mr-10">
          <button @click="directToHelpSupport" class="btn btn-default pl-20 pr-20 btn-md view-btn">
            See More
          </button>
        </div>
      </div>
      <div class="panel-body ml-10 mr-10 pt-0">
        <div class="row">
          <div tabindex="0" class="col-md-12 mt-0 mb-5">
            <h4><b>Featured Videos</b></h4>
            <div>Check out the latest from the Inbox Authoring playlists on YouTube.</div>
          </div>
          <div class="col-md-4 mt-10">
            <iframe
              width="100%"
              height="130"
              :src="`https://www.youtube.com/embed/${authoringTipPlayListData.items[0].videoId}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <img
              src="/capsiminbox/images/youtube-brands-v2.svg"
              class="youtube-icon"
              alt="Youtube icon"
              width="20"
              height="20"
            />
            <a
              :href="`https://www.youtube.com/watch?v=${authoringTipPlayListData.items[0].videoId}&list=${authoringTipPlayListData.playlistId}`"
              target="_blank"
            >
              <strong>Authoring Tips</strong>
            </a>
          </div>
          <div class="col-md-4 mt-10">
            <iframe
              width="100%"
              height="130"
              :src="`https://www.youtube.com/embed/${newAndKeyFeaturesPlaylistData.items[0].videoId}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <img
              src="/capsiminbox/images/youtube-brands-v2.svg"
              class="youtube-icon"
              alt="Youtube icon"
              width="20"
              height="20"
            />
            <a
              :href="`https://www.youtube.com/watch?v=${newAndKeyFeaturesPlaylistData.items[0].videoId}&list=${newAndKeyFeaturesPlaylistData.playlistId}`"
              target="_blank"
            >
              <strong>New & Key Features</strong>
            </a>
          </div>
          <div class="col-md-4 mt-10">
            <iframe
              width="100%"
              height="130"
              :src="`https://www.youtube.com/embed/${featuredProjPlaylistData.items[0].videoId}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <img
              src="/capsiminbox/images/youtube-brands-v2.svg"
              class="youtube-icon"
              alt="Youtube icon"
              width="20"
              height="20"
            />
            <a
              :href="`https://www.youtube.com/watch?v=${featuredProjPlaylistData.items[0].videoId}&list=${featuredProjPlaylistData.playlistId}`"
              target="_blank"
            >
              <strong>Featured Projects</strong>
            </a>
          </div>
          <div tabindex="0" class="col-md-12 mt-20">
            <h4><b>QuickStart Materials</b></h4>
            <div>Ready-to-use content that you can copy and paste into your projects.</div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="col-lg-5ths mt-20 pl-15 first-link-padding">
                <span class="link-text">
                  <i class="fas fa-file-download pr-5"></i
                  ><a
                    @click="handleMilestoneNotification"
                    href="/capsiminbox/resources/CapsimInbox-AP_Character-Examples.pdf"
                    target="_blank"
                    >Sample Characters</a
                  ></span
                >
              </div>
              <div class="col-lg-5ths mt-20 link-padding">
                <span class="link-text">
                  <i class="fas fa-file-download pr-5"></i
                  ><a
                    @click="handleMilestoneNotification"
                    href="/capsiminbox/resources/CapsimInbox-AP_Email-Examples_v1.pdf"
                    target="_blank"
                    >Sample Emails</a
                  ></span
                >
              </div>
              <div class="col-lg-5ths mt-20 link-padding">
                <span class="link-text">
                  <i class="fas fa-file-download pr-5"></i
                  ><a
                    @click="handleMilestoneNotification"
                    href="/capsiminbox/resources/CapsimInbox-AP_Skill-Examples.pdf"
                    target="_blank"
                    >Sample Skills</a
                  ></span
                >
              </div>
              <div class="col-lg-5ths mt-20 link-padding">
                <span class="link-text">
                  <i class="fas fa-file-download pr-5"></i
                  ><a
                    @click="handleMilestoneNotification"
                    href="/capsiminbox/resources/CapsimInbox-AP_Situation-Examples.pdf"
                    target="_blank"
                    >Sample Opening Scene</a
                  ></span
                >
              </div>
              <div class="col-lg-5ths mt-20 link-padding">
                <span class="link-text">
                  <i class="fas fa-file-download pr-5"></i
                  ><a
                    @click="handleMilestoneNotification"
                    href="/capsiminbox/resources/Authoring_Org_Chart_Template.pptx"
                    target="_blank"
                    >Sample Organization Chart</a
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import * as authorApi from '@authoringPlatform/../api/authors';
  export default {
    name: 'ResourceLibrary',
    data() {
      return {
        authoringTipPlayListData: { items: [] },
        featuredProjPlaylistData: { items: [] },
        newAndKeyFeaturesPlaylistData: { items: [] },
        newKeyFeatureVideoId: '',
        playListId: '',
        loadingVideo: true,
      };
    },

    mounted() {
      this.getFirstVideoInYoutubePlaylist();
    },

    methods: {
      ...mapActions(['SET_MILESTONE']),
      async getFirstVideoInYoutubePlaylist() {
        this.loadingVideo = true;
        // playlist id for resource videos
        const authoringTipPlaylistId = 'PLuOs5I8O6S7zlUHzzV4kL1tM_VRxZdcnp';
        const newAndKeyFeaturePlayListId = 'PLuOs5I8O6S7w9kNXeTnT5Q_dZXl5CQlDx';
        const featuredProjPlaylistId = 'PLuOs5I8O6S7wCTVIrWCKmNphauVZzHa73';

        this.authoringTipPlayListData = await authorApi.getPlaylistDataForAuthor(
          authoringTipPlaylistId
        );
        this.newAndKeyFeaturesPlaylistData = await authorApi.getPlaylistDataForAuthor(
          newAndKeyFeaturePlayListId
        );
        this.featuredProjPlaylistData = await authorApi.getPlaylistDataForAuthor(
          featuredProjPlaylistId
        );
        this.loadingVideo = false;
      },
      directToHelpSupport() {
        this.$router.push({ name: 'HelpAndSupport' });
      },
      handleMilestoneNotification() {
        this.SET_MILESTONE({
          message: 'View a QuickStart Material',
          tooltipDesc: this.tooltips.milestones['6'],
          timeout: 8000,
          milestoneKey: 6,
        });
      },
    },
  };
</script>
.
<style lang="scss" scoped>
  .col-lg-5ths {
    position: relative;
    min-height: 1px;
    padding-left: 0px;
  }

  @media (min-width: 768px) {
    .link-padding {
      padding-left: 15px;
    }
  }

  @media (min-width: 1200px) {
    .col-lg-5ths {
      width: auto;
      float: left;
    }
  }

  @media (min-width: 1735px) {
    .link-padding {
      padding-left: 15px;
    }
    .link-padding,
    .first-link-padding {
      padding-right: 20px;
    }
  }

  @media (min-width: 1663px) and (max-width: 1734px) {
    .link-padding {
      padding-left: 10px;
    }
    .first-link-padding,
    .link-padding {
      padding-right: 10px;
    }
  }

  @media (min-width: 1600px) and (max-width: 1662px) {
    .link-padding {
      padding-left: 15px;
    }
    .first-link-padding,
    .link-padding {
      padding-right: 55px;
    }
  }

  @media (min-width: 1591px) and (max-width: 1599px) {
    .link-padding {
      padding-left: 5px;
    }
    .first-link-padding,
    .link-padding {
      padding-right: 5px;
    }
  }

  @media (min-width: 1200px) and (max-width: 1590px) {
    .link-padding {
      padding-left: 15px;
    }
    .first-link-padding,
    .link-padding {
      padding-right: 10px;
    }
  }

  .version-card {
    .panel-heading,
    .panel-footer {
      background: white;
    }
  }

  .panel-heading {
    border: 0px solid transparent;
  }

  a {
    text-decoration: underline;
  }

  h4 {
    margin-bottom: 0;
  }

  .link-text {
    font-size: 17px;
  }
</style>
